<template>
  <div id="app_dashboard_admin">
    <v-row align="center" justify="center">
      <v-col cols="12">
        <OutletMapDashboardComponentFour 
          :dealerCount="dashboardData?.totalActiveDealerCount || 0"
          :routeCount="dashboardData?.totalRouteCount || 0"
          :leadCount="dashboardData?.totalLeadCount || 0"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OutletMapDashboardComponentFour from "@/components/MAP/dashboard_outlet_map_component_four.vue";

export default {
  name: 'outletMap',
  
  props: {
    dashboardData: {
      type: Object,
      default: null
    }
  },

  components: {
    OutletMapDashboardComponentFour
  }
};
</script>

<style>
@import "../../styles/dashboard/dashboard.scss";
</style>